module.exports = __webpack_public_path__ + "img/icon-other.ddd0459f.png";